import { useEffect, useRef, useState } from 'react';

export default function ReactionFeed({ reactions = [] }) {
  const [visible, setVisible] = useState([]);
  const seenRef = useRef(new Set());
  const containerRef = useRef(null);

  useEffect(() => {
    // Show only new reactions
    const newOnes = reactions.filter(r => !seenRef.current.has(r.reaction_id));
    if (newOnes.length === 0) return;

    newOnes.forEach(r => seenRef.current.add(r.reaction_id));

    setVisible(prev => {
      const updated = [...prev, ...newOnes.map(r => ({ ...r, _show: true }))];
      // Keep last 8
      return updated.slice(-8);
    });

    // Auto-remove old items after 4s
    const timeout = setTimeout(() => {
      setVisible(prev => prev.slice(newOnes.length));
    }, 4000);

    return () => clearTimeout(timeout);
  }, [reactions]);

  if (visible.length === 0) return null;

  const actionVerbs = {
    fire: 'sent',
    mic: 'dropped',
    rocket: 'boosted energy',
    diamond: 'dropped',
    laugh: 'sent',
    bolt: 'powered up',
  };

  return (
    <div
      ref={containerRef}
      className="fixed left-4 bottom-24 z-[75] pointer-events-none flex flex-col gap-1 max-w-[280px]"
      data-testid="reaction-feed"
    >
      {visible.map((r, i) => (
        <div
          key={r.reaction_id || i}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/50 backdrop-blur-sm border border-white/5 animate-slide-in-left ${
            r.is_super ? 'ring-1 ring-amber-500/50 bg-amber-900/20' : ''
          }`}
          style={{ animationDelay: `${i * 50}ms` }}
        >
          <span className={`${r.is_super ? 'text-xl' : 'text-base'}`}>{r.emoji}</span>
          <span className="text-xs text-white/80 truncate">
            <span className={`font-bold ${r.is_super ? 'text-amber-400' : 'text-white'}`}>@{r.user_handle}</span>
            {' '}
            <span className="text-white/50">{actionVerbs[r.reaction_type] || 'sent'} {r.emoji}</span>
          </span>
          {r.is_super && (
            <span className="text-[8px] font-black text-amber-400 bg-amber-500/20 px-1 rounded">SUPER</span>
          )}
        </div>
      ))}
    </div>
  );
}
